import { forwardRef } from 'react';

import { IconProps } from '.';

export const ExclamationIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M10.1668 14.13C9.96944 14.125 9.7816 14.0443 9.64203 13.9047C9.50246 13.7652 9.42181 13.5773 9.41675 13.38C9.41491 13.1749 9.49395 12.9773 9.63675 12.83C9.782 12.6986 9.97088 12.6259 10.1668 12.6259C10.3626 12.6259 10.5515 12.6986 10.6968 12.83C10.8396 12.9773 10.9186 13.1749 10.9168 13.38C10.9117 13.5773 10.831 13.7652 10.6915 13.9047C10.5519 14.0443 10.3641 14.125 10.1668 14.13Z"
        fill="currentColor"
      />
      <path
        d="M10.1668 5.87C10.581 5.87 10.9168 6.20578 10.9168 6.62V11.12C10.9168 11.5342 10.581 11.87 10.1668 11.87C9.75254 11.87 9.41675 11.5342 9.41675 11.12V6.62C9.41675 6.20578 9.75254 5.87 10.1668 5.87Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6668 10C17.6668 11.4834 17.2269 12.9334 16.4028 14.1668C15.5787 15.4001 14.4073 16.3614 13.0369 16.9291C11.6664 17.4968 10.1584 17.6453 8.70357 17.3559C7.24872 17.0665 5.91234 16.3522 4.86345 15.3033C3.81456 14.2544 3.10025 12.918 2.81086 11.4632C2.52147 10.0083 2.67 8.50032 3.23765 7.12987C3.80531 5.75943 4.76661 4.58809 5.99997 3.76398C7.23334 2.93987 8.68339 2.5 10.1668 2.5C11.1517 2.5 12.1269 2.69399 13.0369 3.0709C13.9468 3.44781 14.7736 4.00026 15.4701 4.6967C16.1665 5.39314 16.7189 6.21993 17.0958 7.12987C17.4728 8.03982 17.6668 9.01509 17.6668 10ZM16.1668 10C16.1668 8.81331 15.8149 7.65327 15.1556 6.66658C14.4963 5.67988 13.5592 4.91085 12.4629 4.45672C11.3665 4.0026 10.1601 3.88378 8.99621 4.11529C7.83232 4.3468 6.76323 4.91824 5.92411 5.75736C5.085 6.59647 4.51355 7.66557 4.28204 8.82946C4.05053 9.99334 4.16935 11.1997 4.62347 12.2961C5.0776 13.3925 5.84664 14.3295 6.83333 14.9888C7.82002 15.6481 8.98006 16 10.1668 16C11.758 16 13.2842 15.3679 14.4094 14.2426C15.5346 13.1174 16.1668 11.5913 16.1668 10Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ExclamationIcon;
